// extracted by css-extract-rspack-plugin
export default {"cls1":"ConfirmationModal-cls1_5GU","cls2":"ConfirmationModal-cls2_2pA ConfirmationModal-cls1_5GU","border":"ConfirmationModal-border_wqQ"};